export enum DrawerState {
    Open,
    Compact,
    Closed,
}
